
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component, Vue } from "vue-property-decorator";
import NR, { CV, Ats } from "@/lib//model/NRXQ/nr";
import Auth from "@/lib/common/auth";
import vuexStore from "@/store/vuex-store";
import AtsTable from "@/views/nr/components/ats-detail-table.vue";
import Model from "@/lib/model/model";
import config from "@/config/config";
class FormData extends Model {
  name = "";
  phone = "";
  email = "";
  isClose = 2; //默认 开启
}

@Component({
  components: { AtsTable }
})
export default class CustomDetailList extends Vue {
  dataReady = false;
  nrToken = "";
  data: any = {}; //表格所有数据
  tableData: any[] = []; //表格list数据
  page = 1;
  pageSize = 10;
  companyId = "";
  search = { name: "", status: 0 };
  showAdd = false;
  formData = new FormData();
  isEdit = false;
  atsCompanyId = "";
  atsUserId = "";
  companyInfo: any = {};
  get loginUrl() {
    console.log(location);
    const url = config.nrHost + "/public/";
    return url;
  }

  rules = {
    name: [{ required: true, message: "请输入客户名称", trigger: "blur" }],
    email: [{ required: true, message: "请输入邮箱号", trigger: "blur" }]
  };

  created() {
    this.nrToken = String(localStorage.getItem("nrToken") || "");
    this.companyId = Auth.companyId;
    this.atsCompanyId = this.$route?.query?.atsCompanyId as string;
    this.getList();
    this.getComanyInfo();
  }
  mounted() {
    //
  }
  //客户公司信息
  async getComanyInfo() {
    await Ats.getAtsCompany({
      companyId: this.companyId,
      atsCompanyId: this.atsCompanyId
    }).then((res: any) => {
      this.companyInfo = res;
    });
  }
  async getList() {
    await Ats.getAtsUserList({
      page: this.page,
      pageSize: this.pageSize,
      companyId: this.companyId,
      atsCompanyId: this.atsCompanyId
    }).then(res => {
      this.data = res;
      this.tableData = this.data.list;
      this.dataReady = true;
    });
  }
  async submit() {
    (this.$refs["form"] as any)?.validate(async (valid: any) => {
      if (valid) {
        let p: any = {};
        p = this.formData;
        p.companyId = this.companyId;
        p.atsCompanyId = this.atsCompanyId;

        if (!this.isEdit) {
          //新建
          await Ats.createAtsUser(p);
        } else {
          //编辑
          p.atsUserId = this.atsUserId;
          await Ats.updateAtsUser(p);
        }
        this.$message.success("保存成功");
        this.close();
        this.getList();
      }
    });
  }

  //新增
  add() {
    this.formData = new FormData();
    this.isEdit = false;
    this.open();
  }
  //编辑
  edit(row: any) {
    this.atsCompanyId = row.atsCompanyId;
    this.atsUserId = row.atsUserId;
    this.formData.assign(row);
    console.log(this.formData);
    this.isEdit = true;
    this.open();
  }
  back() {
    this.$router.go(-1);
  }

  open() {
    this.showAdd = true;
  }
  close() {
    this.showAdd = false;
  }
  copyUrl() {
    //创建input标签
    const input = document.createElement("input");
    //将input的值设置为需要复制的内容
    input.value = this.loginUrl;
    //添加input标签
    document.body.appendChild(input);
    //选中input标签
    input.select();
    //执行复制
    document.execCommand("copy");
    //移除input标签
    document.body.removeChild(input);
    this.$message.success("复制成功");
  }
}
